import { useEffect } from 'react';
import { t } from '../i18n/index.ts';

/** Names the browser tab after the screen ("Forecast · Map My Money") and restores the previous title on unmount. */
export function useDocumentTitle(page: string) {
  useEffect(() => {
    const before = document.title;
    document.title = t('app.docTitle', { page });
    return () => {
      document.title = before;
    };
  }, [page]);
}
